import ApiService from '@/common/api.service'

import { CREATE_NOTIFICATION, RESET_NOTIFICATION_STATE, GET_NOTIFICATIONS } from './actions.type'
import { SET_IS_LOADING, SET_ERROR, RESET_STATE, SET_NOTIFICATIONS } from './mutations.type'

import Progress from '@/common/progress'

export const getDefaultState = () => {
  return {
    isLoading: false,
    notifications: [],
    totalPage: 1,
    error: null
  }
}

const state = getDefaultState()

const getters = {

}

const actions = {
  [CREATE_NOTIFICATION](context, { title, description }) {
    Progress.show()
    context.commit(SET_IS_LOADING, true)
    return new Promise((resolve, reject) => {
      ApiService.post('api/v1/notifications/send', { title: title, description: description, type: 'ANNOUNCEMENT' })
        .then(({ data }) => {
          Progress.hide()
          context.commit(SET_IS_LOADING, false)
          resolve(data)
        }).catch(({ response }) => {
          Progress.hide()
          context.commit(SET_ERROR, response.data)
          reject(response.data)
        })
    })
  },
  async [GET_NOTIFICATIONS](context, page = 1) {
    context.commit(SET_IS_LOADING, true)
    try {
      const res = await ApiService.get('api/v1/notifications', `?limit=10&page=${page}`)
      context.commit(SET_NOTIFICATIONS, res.data)
    } catch ({ response }) {
      context.commit(SET_ERROR, response.data)
    }
  },
  [RESET_NOTIFICATION_STATE](context) {
    context.commit(RESET_STATE)
  }
}

const mutations = {
  [SET_IS_LOADING](state, isLoading) {
    state.isLoading = isLoading
    state.error = null
  },
  [SET_NOTIFICATIONS](state, response) {
    state.isLoading = false
    state.notifications = response.data
    state.totalPage = response.meta.lastPage
  },
  [SET_ERROR](state, error) {
    state.error = error
  },
  [RESET_STATE](state) {
    Object.assign(state, getDefaultState())
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
